import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Users, Calendar, DollarSign, CheckCircle, Search, Filter, MoreHorizontal, Plus, LayoutGrid, List } from 'lucide-react';
const ROSTER = [{
  id: 1,
  name: 'Neon Dreams',
  status: 'active',
  campaigns: 2,
  deals: 5,
  nextShow: 'Jun 14 - Cleveland',
  routeReadiness: 85,
  lineupReadiness: 100,
  owner: 'Alex M.'
}, {
  id: 2,
  name: 'The Midnight Echo',
  status: 'active',
  campaigns: 1,
  deals: 3,
  nextShow: 'Jul 02 - Chicago',
  routeReadiness: 60,
  lineupReadiness: 40,
  owner: 'Sarah K.'
}, {
  id: 3,
  name: 'Sarah Williams',
  status: 'active',
  campaigns: 3,
  deals: 8,
  nextShow: 'Jun 18 - Detroit',
  routeReadiness: 95,
  lineupReadiness: 90,
  owner: 'Alex M.'
}, {
  id: 4,
  name: 'Electric Horizon',
  status: 'inactive',
  campaigns: 0,
  deals: 0,
  nextShow: 'None',
  routeReadiness: 0,
  lineupReadiness: 0,
  owner: 'David L.'
}, {
  id: 5,
  name: 'Luna & The Stars',
  status: 'active',
  campaigns: 1,
  deals: 2,
  nextShow: 'Aug 10 - Denver',
  routeReadiness: 40,
  lineupReadiness: 80,
  owner: 'Sarah K.'
}, {
  id: 6,
  name: 'Crimson Tide',
  status: 'active',
  campaigns: 2,
  deals: 6,
  nextShow: 'Jun 22 - Boston',
  routeReadiness: 75,
  lineupReadiness: 100,
  owner: 'Alex M.'
}];
export function RosterPage() {
  const [viewMode, setViewMode] = useState<'table' | 'grid'>('table');
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="space-y-6" data-id="element-4157">
      <div className="flex items-center justify-between" data-id="element-4158">
        <div data-id="element-4159">
          <h1 className="text-2xl font-bold text-zinc-100" data-id="element-4160">Roster</h1>
          <p className="text-zinc-400" data-id="element-4161">
            Manage your artists and track their readiness.
          </p>
        </div>
        <button className="flex items-center space-x-2 px-4 py-2 bg-amber-500 hover:bg-amber-400 text-zinc-900 font-medium rounded-lg transition-colors" data-id="element-4162">
          <Plus className="w-4 h-4" data-id="element-4163" />
          <span data-id="element-4164">Add Artist</span>
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-4165">
        {[{
        label: 'Total Roster Acts',
        value: '8',
        icon: Users,
        color: 'text-blue-500'
      }, {
        label: 'Active Campaigns',
        value: '12',
        icon: Calendar,
        color: 'text-amber-500'
      }, {
        label: 'Open Deals',
        value: '24',
        icon: DollarSign,
        color: 'text-green-500'
      }, {
        label: 'Confirmed Shows This Month',
        value: '6',
        icon: CheckCircle,
        color: 'text-purple-500'
      }].map((stat, i) => <div key={i} className="p-4 bg-[#14141A] border border-zinc-800 rounded-xl" data-id="element-4166">
            <div className="flex items-center justify-between mb-2" data-id="element-4167">
              <span className="text-sm text-zinc-400" data-id="element-4168">{stat.label}</span>
              <stat.icon className={`w-4 h-4 ${stat.color}`} data-id="element-4169" />
            </div>
            <div className="text-2xl font-bold text-zinc-100" data-id="element-4170">{stat.value}</div>
          </div>)}
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 bg-[#14141A] p-4 border border-zinc-800 rounded-xl" data-id="element-4171">
        <div className="flex items-center space-x-4 flex-1" data-id="element-4172">
          <div className="relative flex-1 max-w-md" data-id="element-4173">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" data-id="element-4174" />
            <input type="text" placeholder="Search roster..." className="w-full pl-9 pr-4 py-2 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-100 focus:outline-none focus:border-amber-500 transition-colors" data-id="element-4175" />
          </div>
          <button className="flex items-center space-x-2 px-3 py-2 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-300 hover:text-zinc-100 transition-colors" data-id="element-4176">
            <Filter className="w-4 h-4" data-id="element-4177" />
            <span data-id="element-4178">Filters</span>
          </button>
        </div>
        <div className="flex items-center space-x-2 bg-zinc-900 border border-zinc-800 rounded-lg p-1" data-id="element-4179">
          <button onClick={() => setViewMode('table')} className={`p-1.5 rounded-md transition-colors ${viewMode === 'table' ? 'bg-zinc-800 text-zinc-100' : 'text-zinc-500 hover:text-zinc-300'}`} data-id="element-4180">
            <List className="w-4 h-4" data-id="element-4181" />
          </button>
          <button onClick={() => setViewMode('grid')} className={`p-1.5 rounded-md transition-colors ${viewMode === 'grid' ? 'bg-zinc-800 text-zinc-100' : 'text-zinc-500 hover:text-zinc-300'}`} data-id="element-4182">
            <LayoutGrid className="w-4 h-4" data-id="element-4183" />
          </button>
        </div>
      </div>

      <div className="bg-[#14141A] border border-zinc-800 rounded-xl overflow-hidden" data-id="element-4184">
        <div className="overflow-x-auto" data-id="element-4185">
          <table className="w-full text-left text-sm" data-id="element-4186">
            <thead className="bg-zinc-900/50 border-b border-zinc-800 text-zinc-400" data-id="element-4187">
              <tr data-id="element-4188">
                <th className="px-4 py-3 font-medium" data-id="element-4189">Artist Name</th>
                <th className="px-4 py-3 font-medium" data-id="element-4190">Status</th>
                <th className="px-4 py-3 font-medium" data-id="element-4191">Active Campaigns</th>
                <th className="px-4 py-3 font-medium" data-id="element-4192">Open Deals</th>
                <th className="px-4 py-3 font-medium" data-id="element-4193">Next Show</th>
                <th className="px-4 py-3 font-medium" data-id="element-4194">Route Readiness</th>
                <th className="px-4 py-3 font-medium" data-id="element-4195">Lineup Readiness</th>
                <th className="px-4 py-3 font-medium" data-id="element-4196">Owner</th>
                <th className="px-4 py-3 font-medium text-right" data-id="element-4197">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-800" data-id="element-4198">
              {ROSTER.map(artist => <tr key={artist.id} className="hover:bg-zinc-900/50 transition-colors group" data-id="element-4199">
                  <td className="px-4 py-3 font-medium text-zinc-100" data-id="element-4200">
                    {artist.name}
                  </td>
                  <td className="px-4 py-3" data-id="element-4201">
                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${artist.status === 'active' ? 'bg-green-500/10 text-green-500' : 'bg-zinc-800 text-zinc-400'}`} data-id="element-4202">
                      {artist.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-zinc-300" data-id="element-4203">
                    {artist.campaigns}
                  </td>
                  <td className="px-4 py-3 text-zinc-300" data-id="element-4204">{artist.deals}</td>
                  <td className="px-4 py-3 text-zinc-300" data-id="element-4205">{artist.nextShow}</td>
                  <td className="px-4 py-3" data-id="element-4206">
                    <div className="flex items-center space-x-2" data-id="element-4207">
                      <div className="flex-1 h-1.5 bg-zinc-800 rounded-full overflow-hidden" data-id="element-4208">
                        <div className={`h-full rounded-full ${artist.routeReadiness > 80 ? 'bg-green-500' : artist.routeReadiness > 40 ? 'bg-amber-500' : 'bg-red-500'}`} style={{
                      width: `${artist.routeReadiness}%`
                    }} data-id="element-4209" />
                      </div>
                      <span className="text-xs text-zinc-500 w-8" data-id="element-4210">
                        {artist.routeReadiness}%
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-3" data-id="element-4211">
                    <div className="flex items-center space-x-2" data-id="element-4212">
                      <div className="flex-1 h-1.5 bg-zinc-800 rounded-full overflow-hidden" data-id="element-4213">
                        <div className={`h-full rounded-full ${artist.lineupReadiness > 80 ? 'bg-green-500' : artist.lineupReadiness > 40 ? 'bg-amber-500' : 'bg-red-500'}`} style={{
                      width: `${artist.lineupReadiness}%`
                    }} data-id="element-4214" />
                      </div>
                      <span className="text-xs text-zinc-500 w-8" data-id="element-4215">
                        {artist.lineupReadiness}%
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-zinc-400" data-id="element-4216">{artist.owner}</td>
                  <td className="px-4 py-3 text-right" data-id="element-4217">
                    <button className="p-1 text-zinc-500 hover:text-zinc-300 transition-colors" data-id="element-4218">
                      <MoreHorizontal className="w-4 h-4" data-id="element-4219" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </motion.div>;
}